import { performancePageMapRoute } from '../analytics/constants/performancePageMapRoute'

export const getPageTypeId = (pathName: string) => {
    const matchingKey = Object.keys(performancePageMapRoute).find((key) =>
        pathName.includes(key)
    )
    if (matchingKey) {
        return performancePageMapRoute[matchingKey]
    } else {
        return 0
    }
}

export default getPageTypeId
